import { WidthArchiveLabel } from '@app/shared/components';
import type { NClients } from '@app/types';

import type { DataNode } from 'antd/es/tree';

export const getServicesTree = (
  services: NClients.ModelClientsFilterData['Services'],
  categories: NClients.ModelClientsFilterData['CategoryServices'],
  searchValue: string
): DataNode[] => {
  const activeCategories = categories.filter((category) => !category.IsDeleted);
  const archivedCategories = categories.filter(
    (category) => category.IsDeleted
  );

  const buildCategoryTree = (
    category: NClients.ModelClientsFilterData['CategoryServices'][number]
  ) => {
    const categoryServices = services

      .filter((service) => service.CategoryId === category.Id)
      .filter(({ Name }) => {
        return Name?.toLowerCase()?.includes(searchValue?.toLowerCase());
      });

    if (categoryServices.length === 0) {
      return null;
    }

    const children = categoryServices.map((service) => ({
      key: `service-${service.Id}`,
      title: (
        <WidthArchiveLabel title={service.Name} isDeleted={service.IsDeleted} />
      ),
      value: service.Id,
      selectable: true,
    }));

    return {
      key: `category-${category.Id}`,
      title: (
        <WidthArchiveLabel
          title={category.Name}
          isDeleted={category.IsDeleted}
        />
      ),
      value: category.Id,
      children,
    };
  };

  const activeCategoryNodes = activeCategories
    .map(buildCategoryTree)
    .filter((node) => node !== null);

  const archivedCategoryNodes = archivedCategories
    .map(buildCategoryTree)
    .filter((node) => node !== null);

  return [...activeCategoryNodes, ...archivedCategoryNodes];
};
